<script setup lang="ts">
import { NAlert, NSpace } from 'naive-ui';
import { useConnectionStore } from '@/stores/connection';

const connectionStore = useConnectionStore();
</script>

<template>
  <NSpace v-if="connectionStore.hasAlerts" vertical :size="0">
    <NAlert
      v-for="alert in connectionStore.alerts"
      :key="alert.id"
      :type="alert.severity === 'error' ? 'error' : 'warning'"
      :closable="alert.retryable"
      @close="connectionStore.clearAlert(alert.id)"
      style="border-radius: 0;"
    >
      {{ alert.message }}
    </NAlert>
  </NSpace>
</template>
